<template>
    <div class="modal_container" :class="{'modal_show':modals[name]}">
        <div class="modal" :class="{'modal_showms':modals[name]}">
            <h2 class="title"><slot name="title"></slot></h2>
            <p class="body">
                <slot name="text"></slot>
            </p>
            <div class="dismiss" v-if="type == 'normal'">
                <button @click="propModal({name: name, bol: false})">OK</button>
            </div>
            <div class="dismiss_game_modal" v-if="type == 'gameModal'">
                <slot name="icons"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
    props: ["name", "type"],

    data() {
        return {

        }
    },

    methods: {
        ...mapActions([
            "propModal"
        ])
    },

    computed: {
        ...mapGetters([
            "modals"
        ])
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/modal";
</style>